<template lang="pug">
  div.w-100
    template(v-if="target ==='REGISTERNAME'")
      .text-center.w-100.text-danger(v-if="value.$dirty && !value.required") {{ $t('error.usernameRequired') }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.minLength") {{ $t("error.isMinLength", { fname: $t('ui.username'), fvalue: "6" }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.maxLength") {{ $t("error.isMaxLength", { fname: $t('ui.username'), fvalue: "20" }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.valid") {{ $t("error.isAlphaNum", { fname: $t('ui.username') }) }}
      .input-feedback(v-else) {{$t('ui.username_guide')}}
    template(v-else-if="target === 'REGISTERNO'")
      .input-feedback(v-if="!value.$invalid || !value.$anyDirty") {{ $t('ui.phone_tips') }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty == true && value.numeric == false") {{ $t("error.isNumeric", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.minLength") {{ $t('ui.phone_tips') }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.maxLength") {{ $t('ui.phone_tips') }}
    template(v-else-if="target === 'REGISTERPW'")
      .input-feedback(:class="{'text-danger' : value.$dirty && value.$error}" v-html="$t('ui.password_tips')")
    template(v-else-if="target === 'REGISTEREMAIL'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty == true && value.email == false") {{ $t("error.isEmail", { fname: name }) }}
    template(v-else-if="target==='LOGIN'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
    template(v-else-if="target === 'ACCNAME'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty == true && !value.alphaAndSpace ") {{ $t("error.isAlpha", { fname: name }) }}
    template(v-else-if="target === 'SECONDARY'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.minLength") {{ $t("error.isMinLength", { fname: name, fvalue: "11" }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.maxLength") {{ $t("error.isMaxLength", { fname: name, fvalue: "20" }) }}
    template(v-else-if="target === 'CURRENTPW'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
    template(v-else-if="target === 'NEWPW'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.minLength") {{ $t("error.isMinLength", { fname: name, fvalue: "6" }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.maxLength") {{ $t("error.isMaxLength", { fname: name, fvalue: "20" }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.isValid") {{ $t("message.newpw_notsame") }}
    template(v-else-if="target === 'CONFIRMPW'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.sameAsPassword") {{ $t("message.pw_notmatched") }}
    template(v-else-if="target === 'WITHDRAW'")
      .text-center.w-100.text-danger(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
      .text-center.w-100.text-danger(v-else-if="value.$dirty && !value.minValue") {{ $t("error.isMinValue", { fname: name, fvalue: "1" }) }}
</template>
<script>
export default {
  props: {
    value: {
      type: Object
    },
    name: {
      type: String
    },
    target:{
      type: String
    }
  }
}
</script>